import { useSelector } from "react-redux";

const GlobalLoader = () => {
  const loading = useSelector((state) => state.common.loading);

  if (!loading) return null;

  return (
    <div className="loader-backdrop">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  );
};

export default GlobalLoader;
